import { useAuthApiFactory as api } from '@/composables/useApiFactory'
import type { UserT } from '@/types/User'

const AuthService = {
  async login({ username, password }: { username: string; password: string }) {
    return api().post<any, { access_token: string; user: UserT }>(`/auth/login/`, { username, password })
  },

  async createAccount({
    username,
    password,
    firstName,
    lastName,
    dateOfBirth,
    avatarUrl,
    email,
    schoolId
  }: {
    username: string
    password: string
    firstName: string
    lastName: string
    dateOfBirth: string
    avatarUrl: string
    email: string
    schoolId: string
  }) {
    return api().post<any, { access_token: string; user: UserT }>(`/auth/signup/`, {
      username,
      password,
      firstName,
      lastName,
      dateOfBirth,
      avatarUrl,
      ...(email ? { email } : {}),
      ...(schoolId ? { schoolId } : {})
    })
  },

  async passwordReset({ username, dateOfBirth, password }: { username: string; dateOfBirth: string; password: string }) {
    return api().put<any, ApiResponseT<null>>(`/auth/reset/`, { username, dateOfBirth, password })
  }
}

export default AuthService
